module.exports = __webpack_public_path__ + "media/images/youtube-white@2x-af74ed17aab0a83ac1e7dc132a1f3b9c.png";